import { useEffect, useState } from "react";

export default function useIsAtBottom({
  offset = 0,
  skip = false,
}: {
  offset?: number;
  skip?: boolean;
}) {
  const [isAtBottom, setIsAtBottom] = useState(false);

  useEffect(() => {
    if (skip) {
      setIsAtBottom(false);
      return;
    }

    function handleScroll() {
      const scrollY = window.scrollY || window.pageYOffset;
      const windowHeight = window.innerHeight;
      const docHeight = document.documentElement.scrollHeight;
      // You can adjust the offset for "near bottom" detection
      setIsAtBottom(scrollY + windowHeight >= docHeight - offset);
    }

    window.addEventListener("scroll", handleScroll);
    // Call once to set initial value
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, [offset, skip]);

  return isAtBottom;
}
